<template>
  <div class="w-full max-w-4xl mx-auto">
    <div class="flex items-center justify-between relative">
      <!-- Progress bar background -->
      <div class="absolute top-5 left-0 w-full h-2 bg-gray-200 rounded-full" />
      <div
        class="absolute top-5 left-0 h-2 bg-gradient-to-r from-mint-green-200 to-periwinkle-400 rounded-full transition-all duration-500 shadow-lg"
        :style="{ width: `${((currentPage - 1) / (steps.length - 1)) * 100}%` }"
      />
      <!-- Steps -->
      <div
        v-for="step in steps"
        :key="step.number"
        class="relative z-10 flex flex-col items-center flex-1"
      >
        <div
          class="w-12 h-12 rounded-full flex items-center justify-center font-bold text-base transition-all duration-300 mb-3 shadow-lg shrink-0"
          :class="[
            currentPage >= step.number
              ? 'bg-gradient-to-br from-mint-green-200 to-periwinkle-400 scale-110'
              : 'bg-white text-gray-400 border-2 border-gray-200',
          ]"
        >
          <span v-if="currentPage > step.number">
            <Icon class="w-6 h-6" icon="mdi:check-bold" />
          </span>
          <span v-else>{{ step.number }}</span>
        </div>
        <span
          class="text-sm font-semibold transition-colors text-center px-2 min-h-[2.5rem] flex items-start justify-center"
          :class="currentPage >= step.number ? '' : 'text-gray-400'"
        >
          {{ step.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted } from "vue";
import { Icon } from "@iconify/vue";

defineProps({
  currentPage: {
    type: Number,
    required: true,
  },
});

const steps = [
  { number: 1, label: "Dataset Info" },
  { number: 2, label: "Additional Details" },
  { number: 3, label: "Review & Submit" },
];

onMounted(() => {
  // Load Iconify if not already loaded
  if (!document.querySelector('script[src*="iconify"]')) {
    const script = document.createElement("script");
    script.src = "https://code.iconify.design/3/3.1.0/iconify.min.js";
    document.head.appendChild(script);
  }
});
</script>
